import React, { useState } from "react";
import { Pencil } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { tr } from "../i18n";

// Inline-editable project name (double-click or pencil). Saves via PUT /projects/{id}.
export const ProjectName = ({ id, name, onRenamed, className, testId = "project-title", editable = true }) => {
    const [editing, setEditing] = useState(false);
    const commit = async (val) => {
        setEditing(false);
        const v = (val || "").trim();
        if (!v || v === name) return;
        try {
            await api.put(`/projects/${id}`, { name: v });
            onRenamed(v);
        } catch {
            toast.error(tr("msg_rename_failed"));
        }
    };
    if (editing) {
        return (
            <input autoFocus defaultValue={name} data-testid={`${testId}-input`}
                onClick={(e) => e.stopPropagation()}
                onFocus={(e) => e.target.select()}
                onBlur={(e) => commit(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === "Enter") e.currentTarget.blur();
                    if (e.key === "Escape") setEditing(false);
                }}
                className={`${className} min-w-0 bg-[#0b0f17] border border-blue-500/60 rounded px-1.5 py-0.5 focus:outline-none`} />
        );
    }
    return (
        <span className="group/name flex items-center gap-1.5 min-w-0">
            <span data-testid={testId} title={name} onDoubleClick={(e) => { e.stopPropagation(); if (editable) setEditing(true); }}
                className={`${className} truncate`}>{name}</span>
            {editable && <button data-testid={`${testId}-rename`} title={tr("pj_rename")}
                onClick={(e) => { e.stopPropagation(); setEditing(true); }}
                className="shrink-0 p-1 rounded text-slate-500 hover:text-blue-400 hover:bg-blue-500/10 transition-colors">
                <Pencil className="w-3.5 h-3.5" />
            </button>}
        </span>
    );
};
